import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { api, API, setAccessToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = signed out

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        setAccessToken(data.access_token);
        setUser(data.user);
      } catch {
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    setAccessToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/api/auth/register", { name, email, password });
    setAccessToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/api/auth/logout"); } catch {}
    setAccessToken(null);
    setUser(null);
  };

  const logoutAll = async () => {
    try { await api.post("/api/auth/logout-all"); } catch {}
    setAccessToken(null);
    setUser(null);
  };

  const deleteAccount = async () => {
    await api.delete("/api/auth/account");
    setAccessToken(null);
    setUser(null);
  };

  const changePassword = async (current_password, new_password) => {
    const { data } = await api.post("/api/auth/change-password", { current_password, new_password });
    setAccessToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/api/auth/me");
    setUser(data);
    return data;
  };

  const patchUser = (partial) => setUser((u) => ({ ...u, ...partial }));

  return (
    <AuthContext.Provider value={{ user, login, register, logout, logoutAll, deleteAccount, changePassword, refreshUser, patchUser }}>
      {children}
    </AuthContext.Provider>
  );
}
